import React from 'react';
import { Text } from '@wegroup/design-system';
import { isStaging } from '../../../../../../../common/src/utils/globalVariables';
import { useHistory, useLocation } from 'react-router';
import { useFlowsRouteParams } from '../../../../../hooks/useFlowsRouteParams';
import { useTranslation } from 'react-i18next';
import { isSocialLoginUrl } from '../../../../../../../app/src/features/authentication/constants/SocialAuth';

const FlowsToolbarFooter: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { flowId, sessionId } = useFlowsRouteParams();

  const handleOnSecretClick = () => {
    if (isStaging) {
      return history.push(
        `/flows/${flowId}/devtools/${sessionId}/overview?lastRoute=${location.pathname}`,
      );
    }
  };

  const handleOpenCookies = () => {
    const event = new CustomEvent('cookie-preference-open');
    document.dispatchEvent(event);
  };

  return (
    <div>
      {isSocialLoginUrl && (
        <Text
          cursor="pointer"
          _hover={{ textDecor: 'underline' }}
          color="secondary.50"
          fontSize="small"
          onClick={handleOpenCookies}
        >
          {t('COOKIE-PREFERENCES')}
        </Text>
      )}
      <Text color="secondary.50" fontSize="small" onClick={handleOnSecretClick}>
        &copy; {new Date().getFullYear()} WeGroup NV
      </Text>
    </div>
  );
};

export default FlowsToolbarFooter;
